import React from 'react';
import { useSelector } from 'react-redux';

import ExamTableAdmin from 'Components/ExamTables/ExamTableAdmin';
import ExamTableTeacher from 'Components/ExamTables/ExamTableTeacher';
import { getUserType } from 'redux/slices/userSlice';

interface Props {
  mail: string;
}

export default function ExamTable({ mail }: Props) {
  const userTypeSelector = useSelector(getUserType);

  if (userTypeSelector === 'Teacher') {
    return <ExamTableTeacher mail={mail} />;
  } else {
    return <ExamTableAdmin />;
  }
}
